__webpack_require__.p = "/wp-content/plugins/artyseo-simulator/front-app/build/";